import React from 'react'

function LogoutButton(props){

        return (
            <div className='row entry'>
                <div className="form-inline float-md-right">
                    <button type='submit' className='bluebutton' onClick={props.onTakeMeBackClicked}>LOG OUT</button>
                </div>
            </div>
        );
}

export default LogoutButton;